import * as React from "react";

import { Grid, PlatformPageDialog } from "@platform/style";
import WorkTemplateBuilder from "./WorkTemplateBuilder";

export function WorkBuilder() {
  return (
    <PlatformPageDialog
      title={"Work Builder"}
      eventName={"WorkBuilder"}
      showPageHeader={true}
      showCloseIcon={false}
      keepMounted={false}
    >
      <Grid
        sx={{
          height: "calc(-275px + 100vh)",
          maxHeight: "850px",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <WorkTemplateBuilder />
      </Grid>
    </PlatformPageDialog>
  );
}
